/**
 * Nombre del evento Meta: mismo valor en fbq('track', ...) y en CAPI (event_name).
 * Minorista y mayorista usan Purchase; se distinguen por customer_type / content_category.
 */
export const META_PURCHASE_EVENT_NAME = 'Purchase';

/** Valores de custom_data.customer_type (Pixel + CAPI). Deben coincidir byte a byte con el backend. */
export const META_CUSTOMER_TYPE_MAYORISTA = 'mayorista';
export const META_CUSTOMER_TYPE_MINORISTA = 'minorista';

/** content_category en el pixel (solo front; debe alinearse semánticamente con customer_type). */
export const META_CONTENT_CATEGORY_MAYORISTA = 'venta_mayorista';
export const META_CONTENT_CATEGORY_MINORISTA = 'venta_minorista';

export function metaCustomerTypeFromEsMayorista(esMayorista) {
  return esMayorista ? META_CUSTOMER_TYPE_MAYORISTA : META_CUSTOMER_TYPE_MINORISTA;
}

/** Siempre Purchase (minorista y mayorista). */
export function metaEventNameFromCustomerType(_customerType) {
  return META_PURCHASE_EVENT_NAME;
}

export function metaEventNameFromEsMayorista(_esMayorista) {
  return META_PURCHASE_EVENT_NAME;
}

export function metaContentCategoryFromCustomerType(customerType) {
  return customerType === META_CUSTOMER_TYPE_MAYORISTA
    ? META_CONTENT_CATEGORY_MAYORISTA
    : META_CONTENT_CATEGORY_MINORISTA;
}

export function metaContentCategoryFromEsMayorista(esMayorista) {
  return metaContentCategoryFromCustomerType(metaCustomerTypeFromEsMayorista(esMayorista));
}
